"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMELINE_TRACKS = void 0;
exports.DEFAULT_TIMELINE_TRACKS = 90;
